import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

import { withBranch } from '../api/branch';
import { apiFetch } from '../api/client';
import type { GroupSummary } from '../api/types';
import { useViewBranch } from '../view/ViewBranchContext';

type FilesResponse = {
  branch: string;
  groups: GroupSummary[];
};

export const Files = () => {
  const { viewBranch } = useViewBranch();
  const { data, isLoading, error } = useQuery({
    queryKey: ['files', viewBranch],
    queryFn: () => apiFetch<FilesResponse>(withBranch('/api/files', viewBranch)),
  });

  if (isLoading) return <div className="text-sm text-gray-500">読み込み中...</div>;
  if (error !== null) return <div className="text-sm text-red-700">{error.message}</div>;
  if (data === undefined) return null;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold">翻訳ファイル一覧</h2>
        <p className="text-xs text-gray-500">
          ブランチ: <code>{data.branch}</code>
        </p>
      </div>

      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        {data.groups.map((g) => {
          const changed = g.changedLocales.length > 0;
          return (
            <Link
              key={g.id}
              to={`/groups/${g.id}`}
              className={`block rounded border bg-white p-4 hover:border-gray-400 ${
                changed ? 'border-amber-300' : ''
              }`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <h3 className="font-medium">{g.name}</h3>
                  {changed && (
                    <span className="inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-medium text-amber-800">
                      <span className="h-1.5 w-1.5 rounded-full bg-amber-500" />
                      未公開
                    </span>
                  )}
                </div>
                <span className="text-xs text-gray-400 uppercase">{g.fileType}</span>
              </div>
              <p className="mt-1 text-xs text-gray-500">
                {g.locales.length} locales: {g.locales.join(', ')}
              </p>
              {changed && (
                <p className="mt-0.5 text-xs text-amber-700">変更: {g.changedLocales.join(', ')}</p>
              )}
            </Link>
          );
        })}
      </div>
    </div>
  );
};
